let workflow = [
    {
        path: "/travelSq",
        name: "travelSq",
        component: () => import("@/views/jobNavigation/travelBx/travelBx.vue"),
        meta: {
            title: "出差申请",
            keepAlive: true,
            back: true,
        },
    },
    {
        path: "/travelBx",
        name: "travelBx",
        component: () => import("@/views/jobNavigation/travelBx/travelBx.vue"),
        meta: {
            title: "出差费用报销",
            keepAlive: true,
            back: true,
        },
    },
    {
        path: "/cityBx",
        name: "cityBx",
        component: () => import("@/views/jobNavigation/travelBx/travelBx.vue"),
        meta: {
            title: "市内出差报销",
            keepAlive: true,
            back: true,
        },
    },
    {
        path: "/pettyExpenseBx",
        name: "pettyExpenseBx",
        component: () => import("@/views/jobNavigation/travelBx/travelBx.vue"),
        meta: {
            title: "零星费用报销",
            keepAlive: true,
            back: true,
        },
    }, {
        path: "/excessiveApplication",
        name: "excessiveApplication",
        component: () => import("@/views/jobNavigation/travelBx/travelBx.vue"),
        meta: {
            title: "差旅超标申请",
            back: true,
        },
    }, {
        path: "/bx5",
        name: "bx5",
        component: () => import("@/views/jobNavigation/travelBx/travelBx.vue"),
        meta: {
            title: "业务招待费报销",
            keepAlive: true,
            back: true,
        },
    }, {
        path: "/bx6",
        name: "bx6",
        component: () => import("@/views/jobNavigation/travelBx/travelBx.vue"),
        meta: {
            title: "通讯费报销",
            keepAlive: true,
            back: true,
        },
    }, {
        path: "/bx7",
        name: "bx7",
        component: () => import("@/views/jobNavigation/travelBx/travelBx.vue"),
        meta: {
            title: "用车费报销",
            keepAlive: true,
            back: true,
        },
    }, {
        path: "/bx8",
        name: "bx8",
        component: () => import("@/views/jobNavigation/travelBx/travelBx.vue"),
        meta: {
            title: "房费车费报销",
            keepAlive: true,
            back: true,
        },
    }, {
        path: "/bx9",
        name: "bx9",
        component: () => import("@/views/jobNavigation/travelBx/travelBx.vue"),
        meta: {
            title: "日常福利报销",
            keepAlive: true,
            back: true,
        },
    }, {
        path: "/bx10",
        name: "bx10",
        component: () => import("@/views/jobNavigation/travelBx/travelBx.vue"),
        meta: {
            title: "会务费报销",
            keepAlive: true,
            back: true,
        },
    }, {
        path: "/bx11",
        name: "bx11",
        component: () => import("@/views/jobNavigation/travelBx/travelBx.vue"),
        meta: {
            title: "伙食费报销",
            keepAlive: true,
            back: true,
        },
    }, {
        path: "/bx12",
        name: "bx12",
        component: () => import("@/views/jobNavigation/travelBx/travelBx.vue"),
        meta: {
            title: "证照相关费用报销",
            keepAlive: true,
            back: true,
        },
    },{
        path: "/bx13",
        name: "bx13",
        component: () => import("@/views/jobNavigation/travelBx/travelBx.vue"),
        meta: {
            title: "借支申请",
            keepAlive: true,
            back: true,
        },
    },


    {
        path: "/approveCc",
        name: "approveCc",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "出差费用报销审核",
            keepAlive: true
        },
    }, {
        path: "/approveSq",
        name: "approveSq",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "出差申请审核",
            // keepAlive:true
        },
    }, {
        path: "/approveCity",
        name: "approveCity",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "市内出差报销审核",
            keepAlive: true
        },
    }, {
        path: "/approveCb",
        name: "approveCb",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "差旅超标申请审核",
            // keepAlive:true
        },
    }, {
        path: "/approveLx",
        name: "approveLx",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "零星费用报销审核",
            keepAlive: true
        },
    }, {
        path: "/bx5approve",
        name: "bx5approve",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "业务招待费报销审核",
            keepAlive: true
        },
    }, {
        path: "/bx6approve",
        name: "bx6approve",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "通讯费报销审核",
            keepAlive: true
        },
    }, {
        path: "/bx7approve",
        name: "bx7approve",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "用车费报销审核",
            keepAlive: true
        },
    }, {
        path: "/bx8approve",
        name: "bx8approve",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "房费车费报销审核",
            keepAlive: true
        },
    }, {
        path: "/bx9approve",
        name: "bx9approve",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "日常福利报销审核",
            keepAlive: true
        },
    }, {
        path: "/bx10approve",
        name: "bx10approve",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "会务费报销审核",
            keepAlive: true
        },
    }, {
        path: "/bx11approve",
        name: "bx11approve",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "伙食费报销审核",
            keepAlive: true
        },
    }, {
        path: "/bx12approve",
        name: "bx12approve",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "证照相关费用报销审核",
            keepAlive: true
        },
    },{
        path: "/bx13approve",
        name: "bx13approve",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "借支申请审核",
            keepAlive: true
        },
    },

    {
        path: "/ccDetail",
        name: "ccDetail",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "出差费用报销",
            // keepAlive:true
        },
    }, {
        path: "/sqDetail",
        name: "sqDetail",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "出差申请",
            // keepAlive:true
        },
    }, {
        path: "/cityDetail",
        name: "cityDetail",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "市内出差报销",
            // keepAlive:true
        },
    }, {
        path: "/cbDetail",
        name: "cbDetail",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "差旅超标申请",
            // keepAlive:true
        },
    }, {
        path: "/lxDetail",
        name: "lxDetail",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "零星费用报销",
            // keepAlive:true
        },
    }, {
        path: "/bx5detail",
        name: "bx5detail",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "业务招待费报销",
            // keepAlive:true
        },
    }, {
        path: "/bx6detail",
        name: "bx6detail",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "通讯费报销",
            // keepAlive:true
        },
    }, {
        path: "/bx7detail",
        name: "bx7detail",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "用车费报销",
            // keepAlive:true
        },
    }, {
        path: "/bx8detail",
        name: "bx8detail",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "房费车费报销",
            // keepAlive:true
        },
    }, {
        path: "/bx9detail",
        name: "bx9detail",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "日常福利报销",
            // keepAlive:true
        },
    }, {
        path: "/bx10detail",
        name: "bx10detail",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "会务费报销",
            // keepAlive:true
        },
    }, {
        path: "/bx11detail",
        name: "bx11detail",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "伙食费报销",
            // keepAlive:true
        },
    }, {
        path: "/bx12detail",
        name: "bx12detail",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "证照相关费用",
            // keepAlive:true
        },
    },{
        path: "/bx13detail",
        name: "bx13detail",
        component: () => import("@/views/myItems/approve.vue"),
        meta: {
            title: "借支申请",
            // keepAlive:true
        },
    },

    {
        path: "/selectInvoice",
        name: "selectInvoice",
        component: () => import("@/views/jobNavigation/travelBx/selectInvoice.vue"),
        meta: {
            title: "请选择发票"
        },
    },{
        path: "/selectJzd",
        name: "selectJzd",
        component: () => import("@/views/jobNavigation/travelBx/selectInvoice.vue"),
        meta: {
            title: "关联借支单"
        },
    }, {
        path: "/relevance",
        name: "relevance",
        component: () => import("@/views/jobNavigation/travelBx/relevance.vue"),
        meta: {
            title: "请选择事前关联申请单"
        },
    }, {
        path: "/selectCb",
        name: "selectCb",
        component: () => import("@/views/jobNavigation/travelBx/selectCb.vue"),
        meta: {
            title: "请选择超标申请单"
        },
    }, {
        path: "/bookingSubsidiary",
        name: "bookingSubsidiary",
        component: () => import("@/views/jobNavigation/travelBx/bookingSubsidiary.vue"),
        meta: {
            title: "请选择入账子公司"
        },
    }, {
        path: "/search",
        name: "search",
        component: () => import("@/views/search/search.vue"),
        meta: {
            title: "搜索"
        },
    }, {
        path: "/selectCity",
        name: "selectCity",
        component: () => import("@/views/search/selectCity.vue"),
        meta: {
            title: "选择地点"
        },
    }
]

export default workflow